module.exports = __webpack_public_path__ + "img/20200113160507360截图20200113113304879.ef4e7f7f.jpg";